import { BACKEND_BASE_URL } from "../config/app.config";
import { httpGet, httpPost, httpPostWithFormData } from "./http.service";

const URL = `${BACKEND_BASE_URL}/api/stock-screener`;
const StockMarketUrl = `${BACKEND_BASE_URL}/api/stock-markets`;
const StockSectorsUrl = `${BACKEND_BASE_URL}/api/sectors`;

const getStockScreenData = async (queryParams: any) => {
  try {
    const response = await httpGet(`${URL}?${queryParams}`);
    const data = response?.data;
    return data;
  } catch (error: any) {
    throw error?.data?.error;
  }
};

const getStockMarkets = async () => {
  try {
    const response = await httpGet(`${StockMarketUrl}`);
    const data = response?.data;
    return data;
  } catch (error: any) {
    throw error?.data?.error;
  }
};

const getStockSectors = async () => {
  try {
    const response = await httpGet(`${StockSectorsUrl}`);
    const data = response?.data;
    return data;
  } catch (error: any) {
    throw error?.data?.error;
  }
};

export { getStockScreenData, getStockMarkets, getStockSectors };
